<template>
  <div class="">
    <div class="flex justify-between mb-2">
      <h1 class="pt-1">Tips</h1>
    </div>

    <div class="horizontal-scroll py-2">
      <div class="card bg-teal-500 mr-5 tips-item">
        <h2 class="">Cara Transaksi Laundry</h2>
        <img
          src="../../assets/icon/transaksi.png"
          class="h-20 mx-auto mt-3"
          alt=""
        />
      </div>
      <div class="card bg-yellow-400 mr-5 tips-item">
        <h2 class="">Cara Pembayaran Laundry</h2>
        <img
          src="../../assets/icon/pembayaran.png"
          class="h-20 mx-auto mt-3"
          alt=""
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style></style>
